import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconPrint';
/** Renders an SVG icon. */
const SvgPrint = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M21 19H11v9h10zm-3 5a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2zm-3-3a1 1 0 1 1 0 2h-1a1 1 0 1 1 0-2zm10-8a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2zM12.414 6H13v-.586zM28 13a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h3v-3H8a1 1 0 1 1 0-2h16a1 1 0 1 1 0 2h-1v3h3a2 2 0 0 0 2-2zM15 4v3a1 1 0 0 1-1 1h-3v1h10V4zm8 5h3a4 4 0 0 1 4 4v7a4 4 0 0 1-4 4h-3v4a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2v-4H6a4 4 0 0 1-4-4v-7a4 4 0 0 1 4-4h3V6.586L13.586 2H21a2 2 0 0 1 2 2z"
      />
    </svg>
  );
};
SvgPrint.displayName = displayName;
export default SvgPrint;
